import API, { defaultHeaders } from '@/api';

const fetchStats = () => {
  const headers = Object.assign({}, defaultHeaders);
  headers.Authorization = `Bearer ${sessionStorage.getItem('token')}`;
  return fetch(`${API}/panel/stats/dashboard`, { headers });
};

export default fetchStats;
